import * as React from "react";

export const LoadingProduct: React.FunctionComponent = () => {
  return (
    <section className="product-loading">
      <span>Verifying Product Availability</span>
      <div className="loader"></div>
    </section>
  );
};
